import React from 'react';

interface Props {
  children?: React.ReactNode;
}

const LinkTabs = ({ children }: Props) => (
  <div
    className="w100 row bb-solid b-width-2"
    style={{ borderBottomColor: '#e6e6e6' }}
  >
    {children}
  </div>
);

export default LinkTabs;
